<template>
	<div class="upZzBox">
		<div class="upZzTab">上传资源</div>
		<div class="upZzCont">
			<el-row>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demoRuleForm">
					<el-col :span="16" v-if="errFlag">
						<el-form-item label="驳回原因">
							<div class="errHz" v-html="csData.reason"></div>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="标题" prop="title">
							<div class="textBox" style="padding: 0">
								<el-input v-model="ruleForm.title" placeholder="请输入" maxlength="30"></el-input>
								<span>{{ ruleForm.title.length }}/30</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="简介" prop="intro">
							<div class="textBox">
								<el-input v-model="ruleForm.intro" placeholder="请输入" type="textarea" maxlength="150" resize="none" :rows="6"></el-input>
								<span>{{ ruleForm.intro.length }}/150</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="分类" prop="classificationId">
							<!-- <el-select v-model="ruleForm.classificationId" style="width:100%" placeholder="请选择" clearable>
                  <el-option v-for="(item,index) in classArr" :key="index" :label="item.resourceClassificationName" :value="item.resourceClassificationId"></el-option>
                </el-select> -->
							<el-cascader
								v-model="ruleForm.classificationId"
								:options="classArr"
								style="width: 100%"
								:props="{
									checkStrictly: true,
									label: 'resourceClassificationName',
									value: 'resourceClassificationId'
								}"
								clearable
							></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="关键词" prop="keywords">
							<div class="gjzBox">
								<el-select
									v-model="keyArr[index]"
									v-for="(item, index) in keyArr"
									:key="index"
									@change="changeFn(index)"
									maxlength="12"
									class="gjzInput"
									clearable
									filterable
									allow-create
									default-first-option
									placeholder="请选择"
								>
									<el-option v-for="item in gjzOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>

								<!-- <el-input v-model="ruleForm.gjz[index]" v-for="(item,index) in ruleForm.gjz" :key="index" placeholder="请输入" maxlength="7" class="gjzInput"></el-input> -->
								<img src="@/assets/img/tj.png" @click="gjzBtn" alt="" />
								<div class="gjzP">请输入7字以内关键词，最多5个关键词</div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="附件资源" prop="resourceFileId">
							<div class="fjzyBox">
								<el-upload
									class="upload-demo"
									ref="upload"
									:data="{
										pid: 3
									}"
									:multiple="false"
									accept=".txt,.doc,.docx,.rtf,.pdf,.ppt,.pptx,.xls,.xlsx,.mp3,.wav,.mov,.mp4,.jpg,.png,.gif"
									:limit="1"
									:before-remove="handleAvatarRemove"
									:on-success="handleAvatarSuccess"
									:action="upHttpUrl"
									:before-upload="befUpfn"
									:http-request="uploadImage"
									:file-list="fileList"
								>
									<div slot="trigger" class="upWzBtn">
										<img src="@/assets/img/sc 2.png" alt="" class="img" />
										<span>点击上传</span>
									</div>
									<div slot="tip" class="el-upload__tip">
										<span class="upTip">格式为：.rar .zip .doc .docx .pdf .jpg...</span>
									</div>
								</el-upload>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="">
							<div class="regFot">
								<div class="regBtn" @click="qxBtn">取消</div>
								<div class="regBtn active" @click="upBtn">确认</div>
							</div>
						</el-form-item>
					</el-col>
				</el-form>
			</el-row>
			<div class="errBox" v-if="false">
				<i class="el-icon-close errIcon" @click.stop="errFlag = false"></i>
				<div class="errLef">
					<img src="@/assets/img/Shape.svg" alt="" />
				</div>
				<div class="errRig">
					<div class="errTit">驳回原因</div>
					<p v-html="csData.reason"></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'upZz',
	data() {
		return {
			fileList: [],
			ruleForm: {
				title: '',
				intro: '',
				keywords: '',
				classificationId: [],
				resourceFileId: '',
				mutualAidResourceId: ''
			},
			errFlag: false,
			classArr: [],
			upHttpUrl: '',
			upHttpKey: '',
			wjName: '',
			keyArr: [''],
			gjzOptions: [],
			rules: {
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				intro: [{ required: true, message: '请输入简介', trigger: 'blur' }],
				classificationId: [{ required: true, message: '请选择分类', trigger: 'change' }],
				keywords: [{ required: true, message: '请至少输入一个关键字', trigger: 'change' }],
				resourceFileId: [{ required: true, message: '请上传附件资源', trigger: 'change' }]
			}
		};
	},
	props: ['csData'],
	watch: {
		keyArr: {
			handler(val) {
				let scFlag = true;
				let arr = val.filter((item) => {
					if (item) {
						scFlag = false;
						return item;
					}
				});
				if (scFlag) {
					this.ruleForm.keywords = '';
				} else {
					this.ruleForm.keywords = arr.join(',');
				}
				console.log(this.ruleForm.keywords, 666);
			},
			deep: true
		}
	},
	methods: {
		uploadImage(file) {
			// 这里的`file`参数是要上传的文件对象
			// 在这里根据需要添加一些逻辑，如显示进度条
			const xhr = new XMLHttpRequest();
			//element-ui默认使用post提交，但是我们生成的url需要使用 put 提交
			//需要指定 put 直传，以及this.upHttpUrl（后端返回的url）
			xhr.open('PUT', this.upHttpUrl, true);
			//设置上传文件的类型
			xhr.setRequestHeader('Content-Type', file.file.type); // 或者 file.type
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						//进入到这里就表明上传成功了
						//我这里对后端返回的url进行截取方便存入数据库，因为前端还需要展示图片
						let indexOf = this.upHttpUrl.indexOf('?');
						console.log(this.upHttpUrl.slice(0, indexOf), xhr.response, 55555);
						this.$http
							.post('api/app/common/upFileAttachment', {
								key: this.upHttpKey,
								originalFileName: this.wjName
							})
							.then((red) => {
								this.ruleForm.resourceFileId = red.data.attId;
								console.log(red);
							});
					} else {
					}
				}
			};
			//发送
			xhr.send(file.file); //或者 file
		},
		async befUpfn(e) {
			console.log(e, 7777);
			this.wjName = e.name;
			await this.$http
				.get('api/app/common/getToken', {
					params: {
						fileName: e.name
					}
				})
				.then((res) => {
					console.log(9999);
					this.upHttpUrl = res.data.host;
					this.upHttpKey = res.data.key;
				});
		},
		changeFn(index) {
			console.log(this.keyArr[index], 777);
		},
		qxBtn() {
			this.$emit('currCompBtn', 'zzAdmin');
		},
		upBtn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					console.log(this.ruleForm, 8888);
					let { mutualAidResourceId, classificationId, ...ruleForm } = this.ruleForm;
					classificationId = classificationId[classificationId.length - 1];
					if (mutualAidResourceId) {
						// 修改
						this.$http
							.put('api/app/yydMutualAidResource', {
								mutualAidResourceId,
								classificationId,
								...ruleForm
							})
							.then((res) => {
								if (res.code == 200) {
									this.$message({
										type: 'success',
										message: '修改成功'
									});
									this.$emit('currCompBtn', 'zzAdmin');
								}
							});
					} else {
						// 新增
						this.$http
							.post('api/app/yydMutualAidResource', {
								...ruleForm,
								classificationId
							})
							.then((res) => {
								if (res.code == 200) {
									this.$message({
										type: 'success',
										message: '提交成功'
									});
									this.$emit('currCompBtn', 'zzAdmin');
								}
							});
					}
				}
			});
		},
		handleAvatarRemove() {
			this.ruleForm.resourceFileId = '';
		},
		handleAvatarSuccess(res) {
			if (res.code == 200) {
				this.ruleForm.resourceFileId = res.data.attId;
			}
		},
		gjzBtn() {
			if (this.keyArr.length == 5) return;
			this.keyArr.push('');
		},
		// 方法：找到树结构中与 classificationId 匹配的节点及其所有上级节点的 id
		findNodeIds(tree, targetId) {
			const traverse = (node, path = []) => {
				// 当前节点加入路径
				const newPath = [...path, node.resourceClassificationId];

				// 如果找到匹配的节点，返回当前路径
				if (node.resourceClassificationId === targetId) {
					return newPath;
				}

				// 遍历子节点
				if (node.children && node.children.length > 0) {
					for (const child of node.children) {
						const result = traverse(child, newPath);
						if (result) return result; // 找到后立即返回
					}
				}

				return null; // 未找到匹配项
			};

			for (const node of tree) {
				const result = traverse(node);
				if (result) return result;
			}

			return []; // 没有找到匹配项
		},
		funDg(data) {
			return data.map((item) => {
				const { resourceClassificationId, resourceClassificationName, children } = item;
				return {
					resourceClassificationId,
					resourceClassificationName,
					children: children && children.length > 0 ? this.funDg(children) : null
				};
			});
		},
		init() {
			this.$http
				.get('api/app/yydResourceClassification/list', {
					params: {
						categories: 4
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.classArr = this.funDg(res.data || []);
						console.log(this.classArr, 111);
						// 调用方法，查找匹配的节点及其上级节点 id
						const ids = this.findNodeIds(this.classArr, this.csData.classificationId);
						console.log(ids);
						this.$set(this.ruleForm, 'classificationId', ids);
						this.$refs.ruleForm.validate(() => {});
					}
				});
		}
	},
	activated() {
		if (this.csData.classType == 'zzAdmin') {
			console.log(this.csData, 7777);
			let { title, intro, keywords, classificationId, resourceFileId, mutualAidResourceId } = this.csData;
			this.keyArr = keywords?.split(',');
			this.fileList = [
				{
					name: this.csData.resourceFileName,
					url: ''
				}
			];
			this.errFlag = true;
			this.ruleForm = {
				title,
				intro,
				keywords,
				resourceFileId,
				mutualAidResourceId
			};
		}
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.upTip {
	color: #ababab;
}
.upZzBox {
	flex: 1;
	margin-left: 10px;
	background: #fff;
	.upZzTab {
		height: 50px;
		align-items: center;
		color: #000000;
		font-size: 18px;
		padding-left: 19px;
		font-weight: bold;
		line-height: 50px;
		border-bottom: 1px solid #f3f4f7;
	}
	.upZzCont {
		padding-top: 21px;
	}
}
.upWzBtn {
	width: 100px;
	height: 38px;
	background: #ffffff;
	box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
	border-radius: 4px;
	border: 1px solid #d8e0f0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	color: #ababab;
	img {
		width: 14px;
		height: 14px;
		margin-right: 6px;
	}
}
.gjzBox {
	display: flex;
	align-items: center;
	padding-bottom: 26px;
	position: relative;
	flex-wrap: wrap;

	img {
		width: 20px;
		height: 20px;
		cursor: pointer;
		margin-top: -10px;
	}
	.gjzInput {
		width: 120px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	.gjzP {
		color: #bdbdbd;
		font-size: 12px;
		position: absolute;
		bottom: 0;
	}
}
.textBox {
	padding: 4px 0;
	position: relative;
	span {
		color: #ababab;
		position: absolute;
		bottom: 0;
		right: 10px;
		z-index: 999999;
	}
}
.regFot {
	display: flex;
	.regBtn {
		width: 88px;
		height: 40px;
		margin-right: 25px;
		background: #ffffff;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		border: 1px solid #d8e0f0;
		color: #000000;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 16px;
		cursor: pointer;

		&:last-of-type {
			margin-right: 0;
		}
	}

	.active {
		background: #1d7b3a;
		color: #ffffff;
		border: 1px solid #1d7b3a;
	}
}
.errHz {
	color: red;
}
.errBox {
	width: 616px;
	background: #fff1f0;
	border-radius: 4px;
	border: 1px solid #ffa39e;
	padding: 16px 11px 15px 24px;
	display: flex;
	position: fixed;
	top: 120px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 99999999;
	.errIcon {
		position: absolute;
		color: rgba(0, 0, 0, 0.45);
		cursor: pointer;
		top: 18px;
		right: 17px;
	}
	.errLef {
		width: 24px;
		margin-right: 16px;
		img {
			width: 24px;
			height: 24px;
		}
	}
	.errRig {
		flex: 1;
		.errTit {
			font-size: 16px;
			color: rgba(0, 0, 0, 0.85);
			line-height: 24px;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
		p {
			font-size: 14px;
			color: rgba(0, 0, 0, 0.65);
			line-height: 20px;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
	}
}
</style>
